module.exports = __webpack_public_path__ + "img/geo-zones-2-mobile.40e8a9bc.gif";